import {
  createDiagnosticOperationId,
  downloadService,
  reportBrowserError,
  withDiagnosticStep,
} from "@mytour/platform";
import axios from "axios";
import {useCallback, useRef, useState} from "react";
import {certificateApiService} from "../query/certificateApi.service";

export function useDownloadCertificate(eventId: string | undefined, fileName?: string) {
  const downloading = useRef(false);
  const [isDownloadingCertificate, setIsDownloadingCertificate] = useState(false);
  const [downloadCertificateError, setDownloadCertificateError] = useState<string | null>(null);
  const downloadCertificate = useCallback(async () => {
    if (!eventId || downloading.current) {
      return;
    }
    downloading.current = true;
    setIsDownloadingCertificate(true);
    setDownloadCertificateError(null);
    const operationId = createDiagnosticOperationId();
    try {
      const result = await withDiagnosticStep(operationId, "download", () =>
        certificateApiService.downloadFile(eventId)
      );
      await withDiagnosticStep(operationId, "download", () =>
        downloadService.download(
          result.blob,
          fileName ?? result.fileName ?? "attestation-ramonage.pdf",
          {notify: false, throwOnError: true}
        )
      );
    } catch (error) {
      reportBrowserError(error, "attestation-download", {operationId});
      setDownloadCertificateError(
        axios.isAxiosError(error) && error.response?.status === 404
          ? "Le PDF stocké est introuvable."
          : "Erreur lors du téléchargement de l'attestation."
      );
    } finally {
      downloading.current = false;
      setIsDownloadingCertificate(false);
    }
  }, [eventId, fileName]);

  return {downloadCertificate, isDownloadingCertificate, downloadCertificateError};
}
